// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_gRhRE","double":"style_double_2UeKp","title":"style_title_226AF"};